// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  projectId: 'jun-nextstep-dev',
  firebase: {
    apiKey: "AIzaSyC_Dz0oUxRxtkMG5W3PX39g4uJ6oTypfOU",
    authDomain: "jun-nextstep-camp.firebaseapp.com",
    databaseURL: "https://jun-nextstep-camp.firebaseio.com",
    projectId: "jun-nextstep-camp",
    storageBucket: "jun-nextstep-camp.appspot.com",
    messagingSenderId: "251375404584"
  }
};



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/environments/environment.ts